import { useCallback, useEffect, useState } from 'react';
import type { FieldSession } from '@ddp/shared';

import { apiFetch } from '../../api/client.js';

/**
 * Charge et rafraîchit les sessions de vol de l'organisation active.
 *
 * `refresh` est exposé pour être rappelé après une création, une modification ou un déplacement
 * de vidéo : les compteurs par session doivent se mettre à jour sans rechargement de page.
 */
export function useFieldSessions() {
  const [fieldSessions, setFieldSessions] = useState<FieldSession[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const list = await apiFetch<FieldSession[]>('/field-sessions');
      setFieldSessions(list);
    } catch {
      // Rôle sans accès ou aucune session : la barre reste vide, sans bloquer la page.
      setFieldSessions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { fieldSessions, loading, refresh };
}
